import React from 'react';
import {
    AreaChart,
    Area,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer
} from 'recharts';
import { mockAnswerLineGraph } from '../../utils/mock';

const CustomLineGraph = ({ questionData }) => {
    console.log("🚀 ~ CustomLineGraph ~ questionData:", questionData)

    let data = [];

    if (!questionData?.answer) {
        data = Object.keys(mockAnswerLineGraph).map(month => ({
            name: month.slice(0, 3),
            value: mockAnswerLineGraph[month],
        }));
    } else {
        data = Object.keys(questionData.answer).map(month => ({
            name: month.slice(0, 3),
            value: questionData.answer[month],
        }));
    }


    return (
        <ResponsiveContainer width="100%" height={200}>
            <AreaChart
                width={500}
                height={200}
                data={data}
                syncId="anyId"
                margin={{
                    top: 10,
                    right: 30,
                    left: 0,
                    bottom: 0,
                }}
            >
                <defs>
                    <linearGradient id="colorGradient" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8} />
                        <stop offset="95%" stopColor="#82ca9d" stopOpacity={0.1} />
                    </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Area
                    type="monotone"
                    dataKey="value"
                    stroke="#82ca9d"
                    fillOpacity={1}
                    fill="url(#colorGradient)"
                />
            </AreaChart>
        </ResponsiveContainer>
    );
};

export default CustomLineGraph; 